import { useParams } from "react-router-dom";
import { MuiPage } from "../../../components";
import { MuiAccordionArray } from "../../../components/MuiAccordionArray";

import UserEdit from "./user.edit";
import { UserApplicationMapping } from "./userAccordian/user.application";
import { UserRoleMapping } from "./userAccordian/user.role";
import { getLocalStorageItem } from "../../../utils/storageHelper";

export const UserDetails = () => {
    const { id: IdentityId } = useParams()
    const ApplicationId = getLocalStorageItem('ApplicationId')

    const accordionArray = [
        {
            panelId: 'Panel2',
            name: ("Application"),
            child: <UserApplicationMapping request={{ IdentityId, ApplicationId }} />
        },
        {
            panelId: 'Panel3',
            name: ("Role"),
            child: <UserRoleMapping request={{ IdentityId, ApplicationId }} />
        },
    ]

    return (
        <MuiPage>
            <UserEdit />
            {!!IdentityId && (
                <MuiAccordionArray
                    accordionArray={accordionArray}
                />
            )}
        </MuiPage>
    );
}